import { TextSelectionDomConfig } from "./textSelection.types";

export const PDF_TEXT_SELECTION_DOM_CONFIG: TextSelectionDomConfig = {
    pageSelector: ".react-pdf__Page",
    textRootSelector: ".react-pdf__Page__textContent",
    joinLines: true,
};

export const WORD_TEXT_SELECTION_DOM_CONFIG: TextSelectionDomConfig = {
    pageSelector: "section.docx-preview",
    textRootSelector: "section.docx-preview",
    joinLines: false,
};

export const TEXT_VIEW_TEXT_SELECTION_DOM_CONFIG: TextSelectionDomConfig = {
    pageSelector: "section[data-text-page]",
    textRootSelector: "section[data-text-page]",
    joinLines: false,
};
